import React from 'react'
import { getValueElement, printKey } from '../TableCompare/utils'
import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { TableHead } from '@mui/material'

const TableDetailPhotos = ({ photos }) => {
  return (
    <TableContainer component={Box}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align='right' width={80}>
              <Typography component={'p'} color='primary' variant='inherit' className='text-sm py-1 font-bold'>Photo</Typography>
            </TableCell>
            <TableCell>
              <Typography component={'p'} color='primary' variant='inherit' className='text-sm py-1 font-bold'>Status</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { photos.map((field, index) => (
            <TableRow key={`table-columd-body-${field}-${index}`}>
              <TableCell align='right' width={80}>
                <Typography component={'p'} color='primary' variant='inherit' className='text-sm py-1 font-bold'>{field?.name || field}</Typography>
              </TableCell>
              <TableCell>
                <Typography component={'p'} color={field?.error ? 'error' : 'success'} variant='inherit' className='text-sm py-1 overflow-hidden'>{field?.msg || 'Photo uploaded'}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TableDetailPhotos